import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import axios from "axios";
import Slider from "react-slick"; // ✅ import slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import team1 from "../../../assets/images/blog/b-1.png";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const BlogSection = () => {
  const [Bloglist, setBloglist] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [status, setstatus] = useState("");
  const [fooder, setfooder] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    fetchBlogList();
    footerdata();

    // ✅ check screen size
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchBlogList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/blog-list`
      );
      setBloglist(response.data?.data || []);
      setImagePath(response.data?.imagePath || "");
      setstatus(response.data?.status);
    } catch (error) {
      console.error("Blog list fetch error:", error);
    }
  };

  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
    } catch (error) {}
  };

  // Function to limit to 50 words
  const getTrimmedHTML = (html, wordLimit = 50) => {
    const textOnly = html.replace(/<[^>]+>/g, "");
    const words = textOnly.split(/\s+/).slice(0, wordLimit);
    const trimmedText = words.join(" ") + "...";
    const cleanHTML = DOMPurify.sanitize(trimmedText);
    return { __html: cleanHTML };
  };

  const latestBlogs = [...Bloglist]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1.1 },
      },
    ],
  };

  return (
    <>
      {fooder.blogpermission == 1 ? (
        <section className="blogsection py-60">
          <div className="container">
            <div className="section-title mb-48 d-flex justify-content-between align-items-center flex-wrap">
              <div className="heading sec-title">
                <h6 className="color-primary mb-8">–––– Blogs</h6>
                <h2 className="title">
                  Latest News By Talented{" "}
                  <span className="fm-sec">Authors!</span>
                </h2>
              </div>
              <a href="blog" className="educate-btn d-md-block d-none">
                <span className="educate-btn__curve"></span>View All
              </a>
            </div>

            {/* ✅ Grid on desktop, Slider on mobile */}
            {isMobile ? (
              <Slider {...sliderSettings} className="blogSlider">
                {latestBlogs.map((blog, index) => (
                  <div key={index} className="px-2">
                    <div className="blog_card mb-24">
                      <div className="blog_card_img_block">
                        <img
                          src={
                            blog?.image ? `${imagePath}${blog.image}` : team1
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = team1;
                          }}
                          alt={blog?.title || "Blog Image"}
                        />
                        <p className="date">{blog.date}</p>
                      </div>
                      <div className="blog_card_text_block">
                        <h5 className="mb-8">
                          <a className="blog_title" href={blog.link}>
                            {blog.title}
                          </a>
                        </h5>
                        <p
                          className="mb-24"
                          dangerouslySetInnerHTML={getTrimmedHTML(
                            blog.description
                          )}
                        ></p>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="author">
                            <img
                              src={
                                blog?.auth_image
                                  ? `${imagePath}${blog.auth_image}`
                                  : team1
                              }
                              alt="Author"
                            />
                            <h6 className="dark-gray mb-0">{blog.auth_name}</h6>
                          </div>
                          <Link
                            to="/blog-detail"
                            className="h6 color-primary educate_link_btn"
                            onClick={() =>
                              localStorage.setItem("selectedBlogId", blog.id)
                            }
                          >
                            Read More <FaChevronRight />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="row">
                {latestBlogs.map((blog, index) => (
                  <div className="col-lg-4 col-md-6" key={index}>
                    <div className="blog_card mb-24 mb-xl-0">
                      <div className="blog_card_img_block">
                        <img
                          src={
                            blog?.image ? `${imagePath}${blog.image}` : team1
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = team1;
                          }}
                          alt={blog?.title || "Blog Image"}
                        />
                        <p className="date">{blog.date}</p>
                      </div>
                      <div className="blog_card_text_block">
                        <h5 className="mb-8">
                          <a className="blog_title" href={blog.link}>
                            {blog.title}
                          </a>
                        </h5>
                        <p
                          className="mb-24"
                          dangerouslySetInnerHTML={getTrimmedHTML(
                            blog.description
                          )}
                        ></p>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="author">
                            <img
                              src={
                                blog?.auth_image
                                  ? `${imagePath}${blog.auth_image}`
                                  : team1
                              }
                              alt="Author"
                            />
                            <h6 className="dark-gray mb-0">{blog.auth_name}</h6>
                          </div>
                          <Link
                            to="/blog-detail"
                            className="h6 color-primary educate_link_btn"
                            onClick={() =>
                              localStorage.setItem("selectedBlogId", blog.id)
                            }
                          >
                            Read More <FaChevronRight />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default BlogSection;
